import React from "react";
import CountUp from "react-countup";
export default function Facts() {
  return (
    <section id="facts" className="facts">
      <div className="container">
        <div className="section-title"></div>

        <div className="row no-gutters">
          <div
            className="col-lg-4 col-md-4 d-md-flex align-items-md-stretch"
            data-aos="fade-up"
          >
            <div className="count-box">
              <i className="bi bi-emoji-smile"></i>
              <CountUp start={0} end={10} delay={0} suffix="+">
                {({ countUpRef }) => (
                  <div>
                    <span ref={countUpRef} />
                  </div>
                )}
              </CountUp>
              <p>
                <strong>Happy Clients</strong>
              </p>
            </div>
          </div>

          <div
            className="col-lg-4 col-md-4 d-md-flex align-items-md-stretch"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <div className="count-box">
              <i className="bi bi-journal-richtext"></i>
              <CountUp start={0} end={20} delay={0} suffix="+">
                {({ countUpRef }) => (
                  <div>
                    <span ref={countUpRef} />
                  </div>
                )}
              </CountUp>
              <p>
                <strong>Completed Projects</strong>
              </p>
            </div>
          </div>

          <div
            className="col-lg-4 col-md-4 d-md-flex align-items-md-stretch"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div className="count-box">
              <i className="bi bi-calendar-check"></i>
              <CountUp start={0} end={2} delay={0} suffix="+">
                {({ countUpRef }) => (
                  <div>
                    <span ref={countUpRef} />
                  </div>
                )}
              </CountUp>
              <p>
                <strong>Years of Experience</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
